/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type MigrateIssuerRequestBody = {
  /**
   * The remote_session_issuer to migrate away from; soft-deleted on success.
   */
  sourceId: string;
  /**
   * The remote_session_issuer to migrate onto; survives and adopts the source's clients.
   */
  targetId: string;
};

/** @internal */
export type MigrateIssuerRequestBody$Outbound = {
  source_id: string;
  target_id: string;
};

/** @internal */
export const MigrateIssuerRequestBody$outboundSchema: z.ZodMiniType<
  MigrateIssuerRequestBody$Outbound,
  MigrateIssuerRequestBody
> = z.pipe(
  z.object({
    sourceId: z.string(),
    targetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceId: "source_id",
      targetId: "target_id",
    });
  }),
);

export function migrateIssuerRequestBodyToJSON(
  migrateIssuerRequestBody: MigrateIssuerRequestBody,
): string {
  return JSON.stringify(
    MigrateIssuerRequestBody$outboundSchema.parse(migrateIssuerRequestBody),
  );
}
